import { useLDClient } from 'launchdarkly-react-client-sdk'
import Router, { useRouter } from 'next/router'
import { useEffect } from 'react'

import Cookies from 'js-cookie'
import { unprotectedRoutes } from 'middleware'

import { FEATURE_PREVIEW_COOKIE } from '@infura/packages.common/constants'
import { getUserStripeCustomerId } from '@infura/packages.common/user'

import { useUKSServicePlan } from 'hooks/useUKSServicePlan'
import useUser from 'hooks/useUser'

const UserIdentifier = ({ appEnvironment }) => {
  const { isAuthenticated, ldUserIdentified, loading, user } = useUser()
  const { servicePlan } = useUKSServicePlan()
  const ldClient = useLDClient()
  const { asPath } = useRouter()
  const feature_preview = Cookies.get(FEATURE_PREVIEW_COOKIE)

  useEffect(() => {
    const unprotectedRoutesList = [...unprotectedRoutes, '/resendverify']
    const pathNoParams = asPath.split('?')[0]
    const isUnprotectedRoute = unprotectedRoutesList.includes(pathNoParams)
    const isVerifyEmailRoute = pathNoParams.includes('verify')
    if (!isUnprotectedRoute && !isAuthenticated && !loading && !isVerifyEmailRoute) {
      Router.replace('/logout')
    }
  }, [asPath, isAuthenticated, loading])

  useEffect(() => {
    if (ldClient && user && !ldUserIdentified) {
      const contactEmail = user.email || user.contact_email
      if ((window as any).analytics) (window as any).analytics.identify(user.id)
      ldClient.waitUntilReady().then(() =>
        ldClient.identify({
          created_at: new Date(user.created * 1000).toISOString(),
          email: contactEmail,
          ...(feature_preview && { feature_preview }),
          key: user.id,
          kind: 'user',
          plan: servicePlan?.tier
        })
      )
    }

    if (ldClient && !user && !ldUserIdentified) {
      ldClient.waitUntilReady().then(() =>
        ldClient.identify({
          ...(feature_preview && { feature_preview }),
          key: 'ld-anonymous-user-key',
          kind: 'user'
        })
      )
    }
  }, [user, ldClient, ldUserIdentified, servicePlan, feature_preview])

  useEffect(() => {
    if (user && (window as any).profitwell && appEnvironment.production) {
      const id = getUserStripeCustomerId(user)
      if (id) {
        // https://learn.profitwell.com/article/xxxh3rt2pj-how-to-install-the-profit-well-js-snippet
        ;(window as any).profitwell('start', {
          user_id: id
        })
        ;(window as any).dataLayer.push({
          event: 'start_pw_id',
          pw_user_id: id
        })
      } else {
        ;(window as any).profitwell('start', {
          user_email: user.email
        })
        ;(window as any).dataLayer.push({
          event: 'start_pw_email',
          pw_user_email: user.email
        })
      }
    }
  }, [user, appEnvironment])

  return null
}

export default UserIdentifier
